(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('toggleImages');
    if (!btn) return;

    btn.addEventListener('click', function () {
      const extraImages = document.querySelectorAll('.extra-image');
      const expanded = btn.getAttribute('data-expanded') === 'true';

      if (!expanded) {
        extraImages.forEach(function (el) {
          el.style.display = 'block';
        });

        btn.textContent = 'Collapse All Images';
        btn.setAttribute('data-expanded', 'true');
      } else {
        extraImages.forEach(function (el) {
          el.style.display = 'none';
        });

        btn.textContent = 'Show More Images';
        btn.setAttribute('data-expanded', 'false');

        document.getElementById('ProductPhotos-{{ section_id }}').scrollIntoView({
          behavior: 'smooth',
        });
      }
    });
  });

  // front-end-hydration-builder Start
  (function() {
    const initVariantSync = () => {
      const thumbContainer = document.querySelector('.product__thumbs');
      if (!thumbContainer) return;

      const syncVariant = (activeElement) => {
        const img = activeElement.querySelector('img');
        const altText = img ? img.alt.trim() : null;

        if (altText) {
          const dropdowns = document.querySelectorAll('.variant-input-wrap select');
          dropdowns.forEach(select => {
            for (let i = 0; i < select.options.length; i++) {
              // Check if Alt Text matches the option text exactly
              if (select.options[i].text.trim() === altText) {
                if (select.selectedIndex !== i) {
                  select.selectedIndex = i;
                  select.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            }
          });
        }
      };

      // 1. Watch for class changes on thumbnails (for swipes/arrows)
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            if (target.classList.contains('is-active')) {
              syncVariant(target);
            }
          }
        });
      });

      // 2. Start observing all thumbnails
      const thumbs = document.querySelectorAll('.product__thumb');
      thumbs.forEach(thumb => {
        observer.observe(thumb, { attributes: true });
      });

      // 3. Fallback: Keep the click listener for instant response
      thumbContainer.addEventListener('click', (e) => {
        const clickedThumb = e.target.closest('.product__thumb');
        if (clickedThumb) syncVariant(clickedThumb);
      });
    };

    // Initialize on load
    if (document.readyState === 'complete') {
      initVariantSync();
    } else {
      window.addEventListener('load', initVariantSync);
    }
  })();
  // front-end-hydration-builder end

  } catch(e) { console.error(e); }
})();
})();
